/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';



class EmployeeHistoryController {
    public static $inject = [
        '$state',
        '$stateParams',
        'Employee',
        'User'
    ];

    public employee_history;

    constructor(private $state: angular.ui.IStateService,
                private $stateParams: IEmpHistoryState,
                private Employee: IEmpService,
                private User: IUserService)
    {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        if (!User.hasPermission('org.view_employee_history')) {
            $state.go('root.home');
        }

        Employee.getHistory($stateParams.id).then((response) => {
            this.employee_history = response.map((e, i) => {
                // find prev version with same
                var prev = null
                for (var j = i+1; j < response.length; j++) {
                    if (response[j]['field_name'] == e['field_name']) {
                        prev = response[j]
                        break
                    }
                }
                e.diff = window['jsondiffpatch'].diff(prev && prev[e.field_name] || null, e[e.field_name])
                e.diffc = this.convert_diff([e['field_name']], e.diff, [])
                return e
            })
        });
    }

    public convert_diff(path, diff, ret) {
        if (_.isArray(diff)) {
            if (diff.length > 0) {
                if (_.isObject(diff[0])) {
                    diff.map((x, i) => this.convert_diff(path.concat(i), x, ret))
                } else {
                    if (diff.length == 2) {
                        ret.push([path, diff[1]])
                    } else if (diff.length == 1) {
                         ret.push([path, diff[0]])
                    }
                }
            }
        } else if (_.isObject(diff)) {
            _.keys(diff).map((k) => {
                let new_path = path.concat([k.replace('_',' ')])
                if (_.isObject(diff[k])) {
                    this.convert_diff(new_path, diff[k], ret)
                } else if (_.isArray(diff[k])) {
                    this.convert_diff(new_path, diff[k], ret)
                } else {
                    ret.push([new_path, diff[k]])
                }
            })
        }
        return ret
    }

    public when = (e: any) => {
        return e[`${e.field_name}_metadata`].timestamp;
    };
}

angular.module('beneple.global')
    .controller('EmployeeHistoryController', EmployeeHistoryController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-history.controller.ts